import { ClaimType } from '../types/claim.types';
import type { ClaimData } from '../types/claim.types';
import { defaultTrackingBaseUrl } from '../constants';
import { ClaimState } from '@monolog/shared/types';
import { claimStateMapper } from './claims-orders.helper';

/*
  same functionality in ~/apps/valet/helpers/claims.helper.ts

  TODO: merge in the future
*/

/*
  Claim is considered in the item level if:
  * claimType is `MULTIPLE`
  * claim has multiple values for `claimItem.claimType`
*/

export function isClaimItemLevel(claim: ClaimData) {
  if (String(claim.claimType).toUpperCase() === ClaimType.MULTIPLE) {
    return true;
  }

  const uniqueClaimTypes = new Set(claim.claimItems.map(item => item.claimType));
  return uniqueClaimTypes.size > 1;
}

export function isClaimOrderLevel(claim: ClaimData) {
  return !isClaimItemLevel(claim);
}

export const buildTrackingLink = ({
  trackingUrl,
  trackingNumber,
}: {
  trackingUrl?: string;
  trackingNumber?: string;
}) => {
  return trackingUrl ? trackingUrl : defaultTrackingBaseUrl + `/${trackingNumber}`;
};

export const formatClaimType = (claimType?: string) => {
  return claimType?.replace(/_/g, ' ').toLowerCase() ?? '';
};

export const formatClaimState = (claimState: ClaimState) => {
  const state = formatClaimType(claimState);
  return claimStateMapper.label(state);
};

export const ClaimSessionStatusToText: { [key: string]: string } = {
  ISSUES: '/issues',
  PROCESS: '/process',
  ISSUES_ITEMS: '/issues/items',
  ISSUES_SHIPMENT: '/issues/shipment',
  ISSUES_SHIPMENT_DETAILS: '/issues/shipment/details',
  RESOLUTION: '/resolution',
  RESOLUTION_REVIEW: '/resolution/review',
  MULTIPLE_SHIPMENTS: '/multiple-shipments',
};
